/* src/app/modules/display/components/menus/spotlight-menu/building-blocks/menu-item/spotlight-product-menu-item/spotlight-product-menu-item.component.scss */
::ng-deep .force-italic-style * {
  font-style: italic !important;
}
/*# sourceMappingURL=spotlight-product-menu-item.component.css.map */
